import React, { FC } from 'react';
import { ClearIndicatorProps } from 'react-select';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { i18n } from '../../../i18n/translate';
import { FAIcon } from '../../fa-icon';

const ClearIcon: FC = () => <FAIcon icon="xmark" />;

export const SelectClearTooltip = (props: ClearIndicatorProps) => {
  const {
    isMulti,
    children = <ClearIcon />,
    innerProps: { ref, ...restInnerProps },
  } = props;
  const tooltipText = isMulti ? i18n.t('Clear All') : i18n.t('Clear Selection');

  return (
    <OverlayTrigger
      placement="left"
      trigger={['hover', 'focus']}
      delay={800}
      overlay={<Tooltip>{tooltipText}</Tooltip>}
    >
      <div data-action="clear-value" ref={ref} {...restInnerProps}>
        {children}
      </div>
    </OverlayTrigger>
  );
};
